
import { WorldCountry } from '../types';

export const pakistanExpanded: WorldCountry = {
  name: 'Pakistan',
  slug: 'pakistan',
  code: 'PK',
  population: 231402117,
  topCities: [
    { name: 'Karachi', slug: 'karachi', population: 14910352 },
    { name: 'Lahore', slug: 'lahore', population: 11126285 },
    { name: 'Faisalabad', slug: 'faisalabad', population: 3203846 },
    { name: 'Rawalpindi', slug: 'rawalpindi', population: 2098231 },
    { name: 'Gujranwala', slug: 'gujranwala', population: 2027001 },
    { name: 'Peshawar', slug: 'peshawar', population: 1970042 },
    { name: 'Multan', slug: 'multan', population: 1871843 },
    { name: 'Hyderabad', slug: 'hyderabad-pk', population: 1734309 },
    { name: 'Islamabad', slug: 'islamabad', population: 1015000 },
    { name: 'Quetta', slug: 'quetta', population: 1001205 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Sialkot', slug: 'sialkot', population: 655852 },
    { name: 'Bahawalpur', slug: 'bahawalpur', population: 552607 },
    { name: 'Sargodha', slug: 'sargodha', population: 541550 },
    { name: 'Sukkur', slug: 'sukkur', population: 499900 },
    { name: 'Larkana', slug: 'larkana', population: 490508 },
    { name: 'Sheikhupura', slug: 'sheikhupura', population: 473129 },
    { name: 'Jhang', slug: 'jhang', population: 414131 },
    { name: 'Rahim Yar Khan', slug: 'rahim-yar-khan', population: 353112 },
    { name: 'Gujrat', slug: 'gujrat', population: 332506 },
    { name: 'Kasur', slug: 'kasur', population: 314617 },
    { name: 'Mardan', slug: 'mardan', population: 352135 },
    { name: 'Mingora', slug: 'mingora', population: 331091 },
    { name: 'Nawabshah', slug: 'nawabshah', population: 229504 },
    { name: 'Sahiwal', slug: 'sahiwal', population: 235695 },
    { name: 'Okara', slug: 'okara', population: 201815 },
    { name: 'Wah Cantonment', slug: 'wah-cantonment', population: 198891 },
    { name: 'Dera Ghazi Khan', slug: 'dera-ghazi-khan', population: 236093 },
    { name: 'Mirpur Khas', slug: 'mirpur-khas', population: 205913 },
    { name: 'Nawabshah', slug: 'nawabshah-alt', population: 189244 },
    { name: 'Chiniot', slug: 'chiniot', population: 172522 },
    { name: 'Kamoke', slug: 'kamoke', population: 152097 },
    { name: 'Mandi Bahauddin', slug: 'mandi-bahauddin', population: 146982 },
    { name: 'Jhelum', slug: 'jhelum', population: 145647 },
    { name: 'Sadiqabad', slug: 'sadiqabad', population: 141500 },
    { name: 'Jacobabad', slug: 'jacobabad', population: 137648 },
    { name: 'Shikarpur', slug: 'shikarpur', population: 134883 },
    { name: 'Khanewal', slug: 'khanewal', population: 133986 },
    { name: 'Hafizabad', slug: 'hafizabad', population: 130868 },
    { name: 'Kohat', slug: 'kohat', population: 125271 },
    { name: 'Muzaffargarh', slug: 'muzaffargarh', population: 121641 },
    { name: 'Khanpur', slug: 'khanpur', population: 117764 },
    { name: 'Gojra', slug: 'gojra', population: 114766 },
    { name: 'Bahawalnagar', slug: 'bahawalnagar', population: 109331 },
    { name: 'Muridke', slug: 'muridke', population: 102337 },
    { name: 'Pak Pattan', slug: 'pak-pattan', population: 98823 },
    { name: 'Abottabad', slug: 'abottabad', population: 120000 },
    { name: 'Turbat', slug: 'turbat', population: 107927 },
    { name: 'Daska', slug: 'daska', population: 101500 },
    { name: 'Bannu', slug: 'bannu', population: 95057 },
    { name: 'Swabi', slug: 'swabi', population: 96000 },
    { name: 'Mansehra', slug: 'mansehra', population: 87000 },
    { name: 'Charsadda', slug: 'charsadda', population: 89000 },
    { name: 'Nowshera', slug: 'nowshera', population: 89000 },
    { name: 'Karak', slug: 'karak', population: 35000 },
    { name: 'Hangu', slug: 'hangu', population: 52000 },
    { name: 'Parachinar', slug: 'parachinar', population: 43000 },
    { name: 'Tank', slug: 'tank', population: 28000 },
    { name: 'Lakki Marwat', slug: 'lakki-marwat', population: 35000 },
    { name: 'Wazirabad', slug: 'wazirabad', population: 87000 },
    { name: 'Vehari', slug: 'vehari', population: 65000 },
    { name: 'Pakpattan', slug: 'pakpattan-alt', population: 78000 },
    { name: 'Khushab', slug: 'khushab', population: 45000 },
    { name: 'Attock', slug: 'attock', population: 67000 },
    { name: 'Chakwal', slug: 'chakwal', population: 56000 },
    { name: 'Talagang', slug: 'talagang', population: 34000 },
    { name: 'Fateh Jang', slug: 'fateh-jang', population: 43000 },
    { name: 'Taxila', slug: 'taxila', population: 67000 },
    { name: 'Gujar Khan', slug: 'gujar-khan', population: 78000 },
    { name: 'Kahuta', slug: 'kahuta', population: 23000 },
    { name: 'Murree', slug: 'murree', population: 30000 },
    { name: 'Kotli', slug: 'kotli', population: 45000 },
    { name: 'Mirpur', slug: 'mirpur-pk', population: 124000 },
    { name: 'Bhimber', slug: 'bhimber', population: 35000 },
    { name: 'Rawalakot', slug: 'rawalakot', population: 67000 },
    { name: 'Muzaffarabad', slug: 'muzaffarabad', population: 125000 },
    { name: 'Bagh', slug: 'bagh', population: 23000 },
    { name: 'Neelum', slug: 'neelum', population: 12000 },
    { name: 'Hattian', slug: 'hattian', population: 8000 },
    { name: 'Haveli', slug: 'haveli', population: 15000 },
    { name: 'Poonch', slug: 'poonch', population: 43000 },
    { name: 'Sudhnati', slug: 'sudhnati', population: 67000 },
    { name: 'Gilgit', slug: 'gilgit', population: 216760 },
    { name: 'Skardu', slug: 'skardu', population: 74000 },
    { name: 'Hunza', slug: 'hunza', population: 20000 },
    { name: 'Nagar', slug: 'nagar', population: 18000 },
    { name: 'Ghanche', slug: 'ghanche', population: 25000 },
    { name: 'Shigar', slug: 'shigar', population: 15000 },
    { name: 'Khaplu', slug: 'khaplu', population: 12000 },
    { name: 'Gahkuch', slug: 'gahkuch', population: 8000 },
    { name: 'Chilas', slug: 'chilas', population: 18000 },
    { name: 'Astore', slug: 'astore', population: 9000 },
    { name: 'Diamer', slug: 'diamer', population: 23000 },
    { name: 'Ghizer', slug: 'ghizer', population: 34000 },
    { name: 'Kohistan', slug: 'kohistan', population: 45000 },
    { name: 'Shangla', slug: 'shangla', population: 56000 },
    { name: 'Upper Dir', slug: 'upper-dir', population: 67000 },
    { name: 'Lower Dir', slug: 'lower-dir', population: 78000 },
    { name: 'Chitral', slug: 'chitral', population: 89000 },
    { name: 'Kurram', slug: 'kurram', population: 67000 },
    { name: 'Orakzai', slug: 'orakzai', population: 45000 },
    { name: 'Khyber', slug: 'khyber', population: 89000 },
    { name: 'Mohmand', slug: 'mohmand', population: 56000 },
    { name: 'Bajaur', slug: 'bajaur', population: 78000 },
    { name: 'North Waziristan', slug: 'north-waziristan', population: 67000 },
    { name: 'South Waziristan', slug: 'south-waziristan', population: 89000 }
  ]
};
